import React, { Fragment } from 'react';
import { keysIn } from 'lodash';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import HeaderTableCell from '../tabel-component/HeaderTableCell';
import StyledTableCell from '../tabel-component/StyledTableCell';
import TableLoader from '../tabel-component/TableLoader';
import { aixmFeatureKeyMap } from '../../constants/aixmData';

export default function AirportGroundServiceItem({
  isLoading,
  category,
  airportDetails,
  aixmFeatureMapData,
  selctedAirport
}) {
  const airportGroundServiceList = airportDetails[category];
  const airportGroundServiceMap = aixmFeatureMapData['AirportGroundService_list'];
  const airportGroundServiceServiceMap = aixmFeatureMapData['AirportGroundService'];

  return (
    <Fragment>
      {(isLoading || airportGroundServiceList.length === 0) && (
        <TableLoader isLoading={isLoading} data={airportGroundServiceList} />
      )}
      {
        airportGroundServiceList.map((ags, i) => {
          return (
            <Paper sx={{ mb: 5 }} key={`${category}_${i}`}>
              <Table>
                <TableHead>
                  <TableRow>
                    <HeaderTableCell colSpan={2}>
                      {selctedAirport.name} {">"} {aixmFeatureKeyMap[category]} {ags.id}
                    </HeaderTableCell> 
                  </TableRow>
                </TableHead>
                <TableBody>
                  {keysIn(airportGroundServiceMap).map((key, j) => {
                    const airportGroundServiceKey = airportGroundServiceMap[key];

                    return (
                      <TableRow
                        key={j}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <StyledTableCell component="th" scope="row">
                          {key}
                        </StyledTableCell>
                        <StyledTableCell>{ags[airportGroundServiceKey] || "-"}</StyledTableCell>
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell colSpan={2}>
                      {aixmFeatureKeyMap[category]} {">"} Service
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {keysIn(airportGroundServiceServiceMap).map((key, j) => {
                    const trafficSeparationServiceKey = airportGroundServiceServiceMap[key];
                    return (
                      <TableRow
                        key={j}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <StyledTableCell component="th" scope="row">
                          {key}
                        </StyledTableCell>
                        <StyledTableCell>{ags[trafficSeparationServiceKey] || "-"}</StyledTableCell>
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </Paper>
          );
        })
      }
    </Fragment>
  );
}
